import { render, staticRenderFns } from "./Oficio.vue?vue&type=template&id=18e8169f"
import script from "./Oficio.vue?vue&type=script&lang=js"
export * from "./Oficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports